export default __webpack_public_path__ + "static/media/boighor.ca3597db.png";